import React, { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import emailjs from 'emailjs-com';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    projectDetails: '',
    budget: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Type assertion to tell TypeScript the event target is a form
    const form = e.target as HTMLFormElement;
    
    // Send the email using EmailJS
    emailjs.sendForm(
      'service_z7xkae4', // EmailJS service ID
      'template_mu2t2u8', // EmailJS template ID
      form,               // Form element passed directly here
      'Pkiet_rRZ_sk5J5vI' // Your EmailJS public key
    )
    .then((result) => {
      console.log('Email sent:', result.text);
      alert('Your message has been sent!');
    }, (error) => {
      console.error('Error sending email:', error.text);
      alert('Oops! Something went wrong, please try again.');
    });
  };

  return (
    <section className="min-h-screen flex flex-col lg:flex-row">
      {/* Left Side - General Contact Info */}
      <div 
        className="lg:w-1/2 bg-cover bg-center relative p-8 flex flex-col justify-center text-white" 
        style={{ backgroundImage: "url('/images/web-design.jpg')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10">
          <h2 className="text-5xl font-bold mb-4 relative inline-block">
            Contact Us
          </h2>
          <p className="text-xl mb-8">We’re here to help! Reach out to us for any inquiries or support.</p>

          <ul className="space-y-4">
            <li className="flex items-center">
              <FaPhoneAlt className="text-blue-300 mr-4" /> 
              <span>+123 456 7890</span>
            </li>
            <li className="flex items-center">
              <FaEnvelope className="text-blue-300  mr-4" /> 
              <span>contact.elevatecodecreations@gmail.com</span>
            </li>
            <li className="flex items-center">
              <FaMapMarkerAlt className="text-blue-300  mr-4" /> 
              <span>Fort Knox, KY, United States</span>
            </li>
          </ul>

          <div className="mt-8 flex space-x-4">
            <a href="https://www.facebook.com/profile.php?id=61573120152086" target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-slate-700">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/elevate_codecreations/" target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-slate-700">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/in/YourLinkedInProfile" target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-slate-700">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Right Side - Request an Offer Form */}
      <div className="lg:w-1/2 bg-white flex flex-col justify-center p-8 pt-32">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-gray-800 mb-4 relative inline-block">
            Request an Offer
            <img 
              src="/images/unterstrch.png"
              alt="Underline" 
              className="absolute left-1/2 transform -translate-x-3/4 -bottom-4 w-3/4 opacity-80 z-20"
            />
          </h2>
          <p className="text-lg text-gray-600">
            Let’s build something extraordinary together. Fill out the form below, and we'll get in touch with you soon!
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <input 
            type="text" 
            name="name" 
            placeholder="Your Name" 
            value={formData.name} 
            onChange={handleChange}
            className="w-full p-4 border rounded-lg focus:outline-none focus:border-blue-300"
            required
          />
          <input 
            type="email" 
            name="email" 
            placeholder="Your Email" 
            value={formData.email} 
            onChange={handleChange}
            className="w-full p-4 border rounded-lg focus:outline-none focus:border-blue-300"
            required
          />
          <input 
            type="text" 
            name="company" 
            placeholder="Your Company" 
            value={formData.company} 
            onChange={handleChange}
            className="w-full p-4 border rounded-lg focus:outline-none focus:border-blue-300"
          />
          <textarea 
            name="projectDetails" 
            placeholder="Tell us about your project" 
            value={formData.projectDetails} 
            onChange={handleChange}
            className="w-full p-4 border rounded-lg focus:outline-none focus:border-blue-300"
            rows={4}
            required
          />
          <input 
            type="text" 
            name="budget" 
            placeholder="Estimated Budget" 
            value={formData.budget} 
            onChange={handleChange}
            className="w-full p-4 border rounded-lg focus:outline-none focus:border-blue-300 "
          />

          <button 
            type="submit" 
            className="w-full text-blue-300  p-4 rounded-lg hover:text-slate-700 transition"
          >
            Send Request
          </button>
        </form>
      </div>
    </section>
  );
}
